<template>
	<ul id="select_checkbox_input">
		<div class="template_input">
			<label>{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
    		<div id="select_box" v-on:click="open_select">
				<select>
					<option id="title">{{selectTitle}}</option>
				</select>
      			<div id="over_select"></div>
			</div>
			<ul>
				<li v-for="(value, key) in params.choices">
					<input type="checkbox" v-bind:id="params.name+'_'+key" v-bind:value="key" v-model="checkboxRes">
					<label v-bind:for="params.name+'_'+key">{{getLabel(value.label)}}</label>
				</li>
			</ul>
		</div>
	</ul>
</template>

<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

const titleMaxSize = 25;

export default {
	name: 'select_checkbox_input',
	data() {
		return {
			checkboxRes : [],
			fields : {
				fr : {
					select : 'Sélectionner'
				},
				en : {
					select : 'Select'
				}
			},
		}
	},
	props : ['params', 'oldValue', 'lang'],
	methods : {
		validate : function(v) {
			return v.length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		open_select : function(event){
			let element = event.target;
			while(element && element.id != "select_box") element = element.parentElement;
			if(element) element.classList.toggle("active");
		}
	},
	computed : {
		selectTitle : function(){
			if(!this.checkboxRes || !this.checkboxRes.length) return this.fields[this.lang].select;
			let selection = [...this.checkboxRes];
			selection.sort((a,b) => a - b);
			let values = selection.map(e => this.getLabel(this.params.choices[e].label)).join(', ');
			if(values.length > titleMaxSize) values = values.substring(0, titleMaxSize) + '...';
			return values;
		}
	},
	watch: {
		checkboxRes : function(val, old){
			const self = this;
			if(this.params.unique){
				const diff = val.find(e => old.findIndex(k => e === k) == -1);
				if(typeof(diff) != 'undefined') return setTimeout(function(){self.checkboxRes = [diff]}, 50);
			}
			if(this.validate(val)) this.notifyUpdate(val);
			else this.notifyUpdate();
		},
		oldValue : function(val){
			if(!val) this.checkboxRes = [];
		}
	},
	mounted : function(){
		if(Array.isArray(this.oldValue) && this.oldValue.length) this.checkboxRes = this.oldValue;
	}
};
</script>




// WEBPACK FOOTER //
// src/components/candidate_forms/select_checkbox_input.vue